<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t1">Readers love</span> <span class="t2">Rescuing Jack</span></p>
<p class="p2"><span class="t1">by</span> <span class="t3">C</span><span class="t4">AITLIN</span> <span class="t3">R</span><span class="t4">ICCI</span></p>
<p class="p3">“…I can tell that Caitlin Ricci must be an animal lover, it was definitely written with a lot of love and affinity for pets.”</p>
<p class="p4">—Hearts on Fire</p>
<p class="p3">“…a refreshing new way to write about shifters, and a very true look at those who love animals, support adoption through rescue shelters, and believe we all deserve healing hearts and second chances”</p>
<p class="p4">—MM Good Book Reviews</p>
<p class="p3">“Thank you, Caitlin, for a beautiful story of pain, fear, terror, drama, hope, love, family, and the love of a dog.”</p>
<p class="p4">—Rainbow Book Reviews</p>
<p class="p3">“I loved the book… I believe Caitlin Ricci has the beginnings of a wonderful series here.”</p>
<p class="p4">—The Novel Approach</p>
<p class="p3">“<span class="t6">Rescuing Jack</span> is a great starting point for someone thinking about dipping their feet into this genre. The author is one that will pull you in with her story telling…”</p>
<p class="p5">—Top 2 Bottom Reviews</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?505ede10